import { app } from '../../../../../app';

app.component('directoryGroupsSideMenu', {
    bindings: {directories: '<'},
    templateUrl: require('./directory-groups-side-menu.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory-groups-side-menu/directory-groups-side-menu.component.js